// extracted by mini-css-extract-plugin
module.exports = {"modal-trigger":"style_modal-trigger__j3nPH"};